import React, { useMemo } from 'react'

import { Loading, LoadingProps } from '@alpine-iq/ui-library'
import { cssNum } from '@/utils'

export type LoaderProps = {
  fullPage?: boolean
  padding?: string
  height?: string
  fullPageMinusNav?: boolean
  style?: React.CSSProperties
} & LoadingProps

export default function Loader({ height: customHeight, fullPageMinusNav, fullPage, ...props }: LoaderProps) {
  const height = useMemo(() => {
    if (customHeight) return cssNum(customHeight)
    return '100%'
  }, [customHeight])

  return (
    <div
      style={{
        position: 'relative',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height,
        width: '100%',
        padding: cssNum(props.padding || 'auto'),
        ...props.style,
      }}
    >
      <Loading {...props} />
    </div>
  )
}
